var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import cxs from 'cxs/component';
import Theme from 'Theme';
import { T } from 'helpers/i18n';
import { toDate } from 'helpers/Format';
import { Modal, Table } from 'components';
import { Button, DatePicker, FieldSelect } from 'elements';
import { Search } from 'helpers/FuzzySearch';
import theme from 'Theme';
import Storage from '../../../helpers/Storage';
import { typeList } from '../Store';
import SelectTableHeader from '../../../components/SelectTableHeader';
import { TypeTotal } from '../containers/TicketSales';
import View from '../../../elements/View';
import { ListBy } from '../../DashboardTicket/Util/Mapea';
var TicketsReport = /** @class */ (function (_super) {
    __extends(TicketsReport, _super);
    function TicketsReport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            from: new Date(),
            to: new Date(),
            fromVisible: false,
            toVisible: false,
            searchTerm: undefined,
            filterValue: 0,
        };
        _this.typeListSelected = typeList.Calendar;
        /*shouldComponentUpdate(nextProps: Readonly<Props<P>>, nextState: Readonly<State>, nextContext: any): boolean {
          // console.log('TicketsReport - shouldComponentUpdate')
          
          return nextProps.items !== this.props.items ||
            nextState.fromVisible !== this.state.fromVisible ||
            nextState.toVisible !== this.state.toVisible
        }*/
        _this.getFromTo = function () {
            var from = Storage.get('lastDateFrom');
            var to = Storage.get('lastDateTo');
            var _from = from ? new Date(from) : new Date();
            _from.setHours(0, 0, 0, 0);
            var _to = to ? new Date(to) : new Date();
            _to.setHours(23, 59, 59, 999);
            return {
                from: _from,
                to: _to
            };
        };
        _this.handleSearch = function (value) {
            _this.setState({ searchTerm: value });
        };
        _this.toggleFromModal = function () {
            _this.setState({ fromVisible: !_this.state.fromVisible });
            // this.handleOK()
        };
        _this.toggleToModal = function () {
            _this.setState({ toVisible: !_this.state.toVisible });
            // this.handleOK()
        };
        _this.handleOK = function (datePickerName) {
            var fromTo = _this.getFromTo();
            _this.props.onClickOK(fromTo.from, fromTo.to);
            if (datePickerName === 'from') {
                _this.toggleFromModal();
            }
            else if (datePickerName === 'to') {
                _this.toggleToModal();
            }
            else {
                throw new Error('datepicker no válido');
            }
        };
        _this.handleFromChange = function (_, from) {
            Storage.set('lastDateFrom', from);
            if (_this.props.onChangeFrom) {
                _this.props.onChangeFrom(_, from);
            }
            // this.toggleFromModal()
            _this.setState({ from: from });
        };
        _this.handleToChange = function (_, to) {
            Storage.set('lastDateTo', to);
            if (_this.props.onChangeTo) {
                _this.props.onChangeTo(_, to);
            }
            // this.toggleToModal()
            _this.setState({ to: to });
        };
        _this.handleFromKeyPress = function (keyCode) {
            if (keyCode === 13)
                _this.toggleFromModal();
        };
        _this.handleToKeyPress = function (keyCode) {
            if (keyCode === 13)
                _this.toggleToModal();
        };
        _this.filteredItems = function (items) {
            var _a;
            var searchTerm = _this.state.searchTerm;
            var filtrados = items;
            if (_this.props.filters) {
                filtrados = filtrados.filter(_this.props.filters[_this.state.filterValue].filter);
            }
            if (searchTerm) {
                var keysSearchFilter = (_a = _this.props.keysSearchFilter) !== null && _a !== void 0 ? _a : ['username', 'businessUnit', 'numero', 'terminal', 'operationLineName', 'stretchName'];
                var result = Search(searchTerm, filtrados, keysSearchFilter);
                return result;
            }
            return filtrados;
        };
        _this.handleDateFilter = function (name, value, column) {
            if (_this.props.onChangeDateFilter) {
                _this.props.onChangeDateFilter(value);
            }
        };
        _this.handleFilter = function (value) {
            _this.setState({ filterValue: value });
        };
        _this.handleOnSelectItem = function (item) {
            // console.log( 'TicketsReport - handleOnSelectItem - item: ', item)
            _this.props.onSelectItem(item);
        };
        return _this;
    }
    TicketsReport.prototype.componentDidMount = function () {
        if (this.props.lastDates) {
            var fromTo = this.getFromTo();
            this.setState({ from: fromTo.from, to: fromTo.to });
        }
    };
    TicketsReport.prototype.render = function () {
        var _this = this;
        var _a = this.props, header = _a.header, items = _a.items, total = _a.total, format = _a.format, filters = _a.filters, dateFilters = _a.dateFilters, dateFilterSelected = _a.dateFilterSelected, onExport = _a.onExport, onExportPdf = _a.onExportPdf, keyExtractor = _a.keyExtractor, loading = _a.loading, totalNet = _a.totalNet, totalAllocation = _a.totalAllocation, listHeaders = _a.listHeaders, onChangeHeader = _a.onChangeHeader;
        var _b = this.state, from = _b.from, to = _b.to, fromVisible = _b.fromVisible, toVisible = _b.toVisible;
        var filteredItems = this.filteredItems(items);
        var fomatedItems = format(filteredItems);
        var maxTo = new Date();
        maxTo.setDate(maxTo.getDate() + 1);
        return (React.createElement(Wrapper, null,
            React.createElement("div", { style: { flex: 1 } },
                React.createElement("div", { style: { backgroundColor: 'white' } },
                    React.createElement(Header, null,
                        T('from') + ': ',
                        React.createElement(Button, { onClick: this.toggleFromModal }, toDate(from)),
                        T('to') + ': ',
                        React.createElement(Button, { onClick: this.toggleToModal }, toDate(to))),
                    React.createElement(FieldSelect, { key: 'dateFilterSelected', name: 'dateFilterSelected', onChange: this.handleDateFilter, value: dateFilterSelected, options: [
                            {
                                name: T('bySaleDate'),
                                value: ListBy.DateSale
                            },
                            {
                                name: T('byUseDate'),
                                value: ListBy.DateUse
                            }
                        ] }),
                    React.createElement(View, { flex: true, row: true },
                        total &&
                            React.createElement(Total, null,
                                T('total'),
                                " ",
                                total(filteredItems, TypeTotal.total)),
                        totalNet && React.createElement(Total, null,
                            T('totalNet'),
                            " ",
                            totalNet(filteredItems, TypeTotal.totalNet)))),
                React.createElement(SelectTableHeader, { headers: listHeaders, onChangeHeader: onChangeHeader }),
                React.createElement(Table, { onExport: onExport, filters: filters, dateFilters: dateFilters, onFilter: this.handleFilter, onSelectItem: this.handleOnSelectItem, width: "200%", handleSearch: this.handleSearch, items: fomatedItems, header: header, search: this.props.search ? this.props.search : false, xlsx: true, csv: true, keyExtractor: keyExtractor, loading: loading, onExportPdf: onExportPdf }),
                fromVisible && (React.createElement(Modal, { title: T('from') },
                    React.createElement(DatePicker, { withTime: true, name: 'from', date: from, onChange: this.handleFromChange, onKeyPress: this.handleFromKeyPress }),
                    React.createElement("div", { style: {
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%'
                        } },
                        React.createElement(Button, { style: { backgroundColor: theme.color.background, margin: '5px' }, onClick: function () { return _this.handleOK('from'); } }, 'OK')))),
                toVisible && (React.createElement(Modal, { title: T('to') },
                    React.createElement(DatePicker, { withTime: true, name: 'to', date: to, onChange: this.handleToChange, onKeyPress: this.handleToKeyPress }),
                    React.createElement("div", { style: {
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%'
                        } },
                        React.createElement(Button, { style: { backgroundColor: theme.color.background }, onClick: function () { return _this.handleOK('to'); } }, 'OK')))))));
    };
    return TicketsReport;
}(Component));
export default TicketsReport;
var Wrapper = cxs('div')({
/*display: 'flex',
flexDirection: 'row',
justifyContent: 'center',*/
});
var Header = cxs('div')({
    paddingLeft: Theme.size.space[1],
});
var Total = cxs('div')({
    padding: Theme.size.space[1],
    borderTop: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
    textAlign: 'right',
    backgroundColor: 'white',
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/components/TicketsReport.tsx
// module id = 161
// module chunks = 0